import {
  APIProvider,
  Map,
  MapCameraChangedEvent,
  MapCameraProps,
} from '@vis.gl/react-google-maps';
import React, { useCallback, useEffect, useState } from 'react';

import { IDealer } from '@/types/dealer/dealer';

import { ClusteredMarkers } from './clustered-markers';

type IStepParams = {
  dealerId: string;
  branchCode: string;
  title: string;
  district: string;
  province: string;
};

interface DealerResultMapProps {
  center: google.maps.LatLngLiteral;
  selectCenter: google.maps.LatLngLiteral;
  dealers?: IDealer[];
  zoom?: boolean;
  selectedDealer?: IDealer;
  onNextStep?: (params: IStepParams) => void;
  onClickMarker: (id: string) => void;
}

export const DealerResultMap: React.FunctionComponent<DealerResultMapProps> = (
  props: DealerResultMapProps
) => {
  const [isClient, setIsClient] = useState<boolean>(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const handleGoogleApiError = (error: unknown) => {
    alert(
      "ไม่รองรับการใช้งานในประเทศของคุณ / Service isn't available in your location"
    );
  };

  const [cameraProps, setCameraProps] = useState<MapCameraProps>({
    center: props.center,
    zoom: 12,
  });

  const handleCameraChange = useCallback((ev: MapCameraChangedEvent) => {
    setCameraProps(ev.detail);
  }, []);

  return (
    <>
      {!!isClient && (
        <APIProvider
          apiKey={process.env.NEXT_PUBLIC_GOOGLEMAP_API_KEY as string}
          onError={handleGoogleApiError}
        >
          <Map
            {...cameraProps}
            streetViewControl={false}
            fullscreenControl={false}
            mapTypeControl={false}
            onCameraChanged={handleCameraChange}
            mapId={process.env.NEXT_PUBLIC_GOOGLEMAP_MAP_ID as string}
          >
            <ClusteredMarkers
              dealers={props.dealers ?? []}
              selectedDealer={props.selectedDealer}
              onClickMarker={props.onClickMarker}
            />
          </Map>
        </APIProvider>
      )}
    </>
  );
};
DealerResultMap.displayName = 'SectionDealerResultMap';
